import { openBlock as e, createElementBlock as t, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ l("path", {
  "fill-rule": "evenodd",
  d: "M11.963 1.807a.75.75 0 0 1 .817.163l5 5a.75.75 0 0 1-.027 1.086L13.394 12l4.36 3.944a.75.75 0 0 1 .026 1.086l-5 5a.75.75 0 0 1-1.28-.53v-7.786l-4.247 3.842a.75.75 0 0 1-1.006-1.112L11.158 12 6.247 7.556a.75.75 0 1 1 1.006-1.112l4.247 3.842V2.5a.75.75 0 0 1 .463-.693ZM13 13.667l3.162 2.86L13 19.69v-6.023Zm0-3.333V4.31l3.162 3.162L13 10.333Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function a(c, d) {
  return e(), t("svg", o, [...r]);
}
const i = { render: a };
export {
  i as default,
  a as render
};
